// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup/NavGroup";
import adminDashboard from "src/menu-items/AdminDashboard";

import { useEffect, useState } from "react";
import { IconKey } from "@tabler/icons-react";
import NavItem from "./NavItem/NavItem";
import NavCollapse from "./NavCollapse/NavCollapse";

import UserMenu from "src/menu-items/UserMenu";
import InvoiceMenu from "src/menu-items/InvoiceMenu";
import subAdminDashboard from "src/menu-items/SubAdminDashboard";
import TransportMenu from "src/menu-items/TransportMenu";

// constant
const icons = {
  IconKey,
};

const MenuList = ({ AuthRole }) => {
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    let newMenuItems = [];

    const fetchData = async (AuthRole) => {
      // admin and sub admin

      if (AuthRole === 0) {
        newMenuItems = [adminDashboard, UserMenu, InvoiceMenu, TransportMenu];
      } else if (AuthRole == 1) {
        newMenuItems = [subAdminDashboard];
      }

      setMenuItems(newMenuItems);
    };

    fetchData(AuthRole);
  }, [AuthRole]);
  const navItems = menuItems.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      case "collapse":
        return <NavCollapse key={item.id} menu={item} level={1} />;
      case "item":
        return <NavItem key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
